import { Controller } from "@hotwired/stimulus"

// Bootstrap announces show.bs.modal through jQuery's trigger, which dispatches no DOM event, and
// bootstrap-datepicker announces changeDate the same way - so both stay bound through jQuery;
// no data-action wiring can observe either one.
const JQUERY_NAMESPACE = ".adminSubscriptions"

// Mounted on the `simple_form_for` wrapping the subscribe/update modal
// (admin/organizations/subscriptions/_subscribe_modal.html.haml), once for the current
// subscription and once per eligible row in the Available Plans table. That partial is the only
// view that renders this markup, so the Targets/data-action declared on it below are safe (no
// D12-style shared-partial conflict).
//
// The changeDate handler is rebound on every show.bs.modal without unbinding the previous one -
// it's idempotent (the same computed date each time), so the duplicate is harmless.
export default class extends Controller {
  static get targets() { return ["renewalStatus", "nextPlanPrice", "submit"]; }

  connect() {
    this.onShow = this.onShow.bind(this);
    $(this.element).on(`show.bs.modal${JQUERY_NAMESPACE}`, this.onShow);
  }

  disconnect() {
    $(this.element).off(JQUERY_NAMESPACE);
  }

  onShow(event) {
    // `data-default` here is a per-input default (each of the two better_date fields carries its
    // own), not a single controller-level value, so it isn't a Values API candidate.
    event.target.querySelectorAll("input.better_date").forEach((input) => {
      input.value = input.getAttribute("data-default");
    });

    $(event.target).find("#subscription_start_date").datepicker().on(`changeDate${JQUERY_NAMESPACE}`, (e) => {
      const startDate = e.date;
      // Set the next renewal date to 1 year after the start date
      const nextRenewalDate = new Date(startDate);
      nextRenewalDate.setFullYear(startDate.getFullYear() + 1);
      // Set the value of the next renewal date input
      $(event.target).find("#subscription_next_renewal_at").datepicker("update", nextRenewalDate);
    });

    // Show the next subscription plan price based on the renewing status
    this.toggleNextSubscriptionPlanPrice();
  }

  // Bound declaratively (data-action="change->admin-subscriptions#toggleSubmitButton") on both
  // better_date inputs, so each field's own change event gates the button on that field alone -
  // matching the jQuery original's per-input `e.currentTarget` read, not a combined check.
  toggleSubmitButton(event) {
    const isValid = event.currentTarget.value.trim().length > 0;
    this.submitTarget.disabled = !isValid;
  }

  // Bound declaratively on the renewalStatus target's native "change" event - unlike
  // show.bs.modal this is a real DOM event, so no jQuery is needed to observe it. Guarded because
  // the Stripe-connected branch of the partial renders neither target (untested by the covering
  // spec, but a bare Target access would throw there - pitfalls.md P33).
  toggleNextSubscriptionPlanPrice() {
    if (!this.hasRenewalStatusTarget) { return; }

    const changing = this.renewalStatusTarget.value === "changing";
    // No stylesheet rule sets a competing display:none on
    // .subscription_next_subscription_plan_price_id (checked app/assets/stylesheets), so clearing
    // the inline style is a faithful native equivalent of jQuery's .toggle() here.
    this.nextPlanPriceTarget.style.display = changing ? "" : "none";
  }
}
